import React, { FC } from 'react';

import Step from './Step';
import style from './Steps.module.scss';
import { StepsContext } from './StepsContext';

const Steps: FC = () => {
  const { steps } = React.useContext(StepsContext);

  if (!steps || steps.length === 0) { // for error pages
    return null;
  }

  return (
    <nav className={style.steps}>
      <ul>
        {steps.map((step, i) => (
          <Step
            index={i + 1}
            key={step.id}
            step={step}
          />
        ))}
      </ul>
    </nav>
  );
};

export default Steps;
